require('./bootstrap');

$(document).ready(function() {
    let iframe = $('iframe');

    if(iframe.length > 0)
    {
        iframe.on('load', function() {
            setTimeout(resize, 500);
        });
    } else {
        resize();
    }

    $(window).on('resize', function(){
        resize();
    });
});

function resize()
{
    if ((Math.floor($('footer').offset().top + $('footer').height()) <= $(window).height()) || ($('iframe').length > 0)) {
        $('main').attr('style',
            'height: ' + ($('footer').offset().top - $('main').offset().top) + 'px;'
        );
    } else {
        $('main').removeAttr('style');
    }
}



